import type {
  DurationObjectUnits,
  DurationUnit,
  ToHumanDurationOptions,
} from 'luxon';
import { Duration } from 'luxon';

export type IToHumanDurationOptions = ToHumanDurationOptions & {
  minUnit?: DurationUnit;
};

export const toHumanDuration = (
  d: Duration,
  options?: IToHumanDurationOptions,
): string => {
  const units: Array<DurationUnit> = [
    'years',
    'months',
    'days',
    'hours',
    'minutes',
    'seconds',
  ];
  const shiftTo = options?.minUnit
    ? units.slice(0, units.indexOf(options.minUnit) + 1)
    : units;

  // Better Duration.toHuman support https://github.com/moment/luxon/issues/1134
  const duration = d.shiftTo(...shiftTo).toObject();

  const durationEntries = Object.entries(duration).filter(([, v]) => v !== 0);

  const cleanedDuration = Object.fromEntries(
    durationEntries.map(([k, v]) => [k, Math.round(v as number)]),
  ) as DurationObjectUnits;

  if (Object.keys(cleanedDuration).length === 0) {
    cleanedDuration.seconds = 0;
  }

  return Duration.fromObject(cleanedDuration).toHuman(options);
};
